import { Component, OnInit, Inject } from '@angular/core';
import { formatDate } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToWords } from 'to-words';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-issue-seller-invoice-bill',
  standalone: false,
  templateUrl: './issue-seller-invoice-bill.component.html',
  styleUrl: './issue-seller-invoice-bill.component.scss'
})
export class IssueSellerInvoiceBillComponent {

  date = new Date();
  issuenames = '';
  issueDates = '';
  advtName = '';
  billno = '';
  isupdate:boolean = false
  advtData = [];
  filteredData;
  isLoading = false;

  printShowData :any= [];
  issueName: any;
  percentage: number;
  cgstpercentage: number;
  sgstpercentage: number;
  convertToWords: any;
  constructor(
    private dialogRef: MatDialogRef<IssueSellerInvoiceBillComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toaster: ToastrService,
    private service: DigisubservicesService
  ) {}
  ngOnInit(): void {
   
    this.isLoading = true;
    // console.log(this.data);
    this.issuenames = this.data['issuenames'];
    this.issueName = this.data['issueName'];
    this.issueDates = this.data['issueDates'];
    this.advtName = this.data['issueSellerName'];
    this.date = this.data['date'];
    this.billno = this.data['billno'];
    this.isupdate = this.data['isupdate']
    this.getData();
  }

  getData() {
    debugger
    this.service.getIssueSellerBookingList().subscribe((res: any) => {
      this.advtData = res;
      console.log(this.advtData);
      this.filterData();
    });
  }
 filterData() {
    // console.log('called');
    if (this.issuenames != '' && this.issueDates != '' && this.advtName == '') {
      this.filteredData = this.advtData.filter((a) => {
        return (
          this.issuenames === a['issue_name_id'] &&
          this.issueDates.includes(a['issue_date'])
        );
      });
      // console.log('filteredData', this.filteredData);
    } else if (
      this.issuenames == '' &&
      this.issueDates == '' &&
      this.advtName !== ''
    ) {
      this.filteredData = this.advtData.filter((a) => {
        return Array.isArray(this.advtName) && this.advtName.includes(a['issue_seller_id']);

      });
      // console.log('filteredData', this.filteredData);
    } else if (
      this.issuenames != '' &&
      this.issueDates != '' &&
      this.advtName != ''
    ) {
      this.filteredData = this.advtData.filter((a) => {
        return (
          this.issuenames === a['issue_category_id'] &&
          this.issueDates.includes(a['issue_date']+","+a['issue_name_id']) &&
          this.advtName.includes(a['issue_seller_id']) &&
          a['issue_seller_id']!=""
        );
      });
      // console.log('filteredData', this.filteredData);
      // console.log('filteredData length', this.filteredData.length);
    }

    setTimeout(() => {
      this.setData();
    }, 500);
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  setData() {
    if (this.filteredData.length == 0) {
        this.isLoading = false;
        alert('Data is not Present.');
        this.dialogRef.close();
        return;
    }

    let data = this.uniqueid(this.filteredData, (a) => a.issue_seller_id);
    let parentIndex = 0;
    let remainingData: any[] = [];

    for (let i = 0; i < data.length; i++) {
      debugger
        let eachData = this.filteredData.filter((a) => data[i]['issue_seller_id'] == a.issue_seller_id);

        while (eachData.length > 0) {
            let showData:any = {
                invoice_no: '',
                advt_name: '',
                address: '',
                state: '',
                cust_gst_no: '',
                cust_name: '',
                ro_no: '',
                ro_date: '',
                advt_order_no: '',
                advt_order_date: '',
                firstweek: this.getEmptyWeekData(),
                secondweek: this.getEmptyWeekData(),
                thirdweek: this.getEmptyWeekData(),
                fourthweek: this.getEmptyWeekData(),
                fifthweek: this.getEmptyWeekData(),
                issueName:'',
                issue_copies:0,
                total_amt: {
                    page_no: 0,
                    advt_rate: 0,
                    dis: 0,
                    net: 0,
                    cgst: 0,
                    sgst: 0,
                    igst: 0,
                    round_off: 0,
                    total: 0,
                },
                total_in_words: '',
                pre_bal: 0,
                total: 0,
                remaining_amt: 0,
                opening_bal: 0,
            };

            // Create invoice number
            showData['invoice_no'] = `${this.billno.split('/')[0]}/${this.billno.split('/')[1]}/${this.billno.split('/')[2]}/${('0000' + (parseInt(this.billno.split('/')[3]) + parentIndex)).slice(-4)}`;
            showData['advt_name'] = eachData[0]['issue_seller_id'];
            showData['advt_order_no'] = eachData[0]['booking_number'];
            showData['advt_order_date'] = eachData[0]['booking_date'];
            showData['cust_name'] = eachData[0]['cust_name'];
            showData['cust_gst_no'] = eachData[0]['gst_no'];
            showData['address'] = eachData[0]['address'];
            showData['state'] = eachData[0]['state'];
            showData['issuenames'] = eachData[0]['issue_name_id'];
            showData['issueName'] = eachData[0]['issue_name_id'];
            showData['total_amount'] = eachData[0]['total_amount'];
            showData['is_gst_type'] = eachData[0]['issue_seller_gst_type'];
            this.percentage = parseFloat(eachData[0]['issue_seller_gst_per']);
            this.cgstpercentage = parseFloat(eachData[0]['issue_seller_gst_per'])/2;
            this.sgstpercentage = parseFloat(eachData[0]['issue_seller_gst_per'])/2;
              showData['opening_bal'] = eachData[0]['opening_bal'] || 0;
           console.log("Opening Balance Set For", showData['advt_name'], ":", showData['opening_bal']);


            let remainingData: any[] = [];

            for (let index = 0; index < eachData.length; index++) {
                let issuedate = eachData[index]['issue_date'].split(',')[0];
                let firstdate = formatDate(this.firstSunday(this.date.getMonth(), this.date.getFullYear()), 'dd/MM/yyyy', 'en-IN', 'GMT+0530');
                const weekData = {
                    id: eachData[index]['id'],
                    issue_date: issuedate,
                    // issueName:this.issueName,
                    issue_copies: Number(eachData[index]['issue_copies']),
                    issue_seller_price: Number(Math.round(eachData[index]['issue_seller_price'])),
                    issue_total_price: Number(eachData[index]['issue_copies'])*Number(Math.round(eachData[index]['issue_seller_price'])),
                    hsn: '4902',
                    advt_rate: Number(Math.round(eachData[index]['without_gst_amount'])),
                    without_gst_amount: Math.round(eachData[index]['without_gst_amount']),
                    dis: Number(Math.round(eachData[index]['issue_selling_discount_amt'])),
                    net_amount: Number(Math.round(eachData[index]['net_amount'])),
                    cgst: Number(Math.round(Number(eachData[index]['with_gst_amount'])-Number(eachData[index]['without_gst_amount']))/2),
                    sgst: Number(Math.round(Number(eachData[index]['with_gst_amount'])-Number(eachData[index]['without_gst_amount']))/2),
                    igst: Number(Math.round(0)),
                    round_off: Math.round(eachData[index]['net_amount']),
                    total: Math.round(eachData[index]['issue_copies']),
                    gstype: Math.round(eachData[index]['issue_seller_gst_type']),
                    issueName: eachData[index]['issue_name_id'],
                    with_gst_amount: Math.round(eachData[index]['with_gst_amount']),
                    is_gst_type: eachData[index]['issue_seller_gst_type'],
                    total_amount : eachData[index]['total_amount'],
                    opening_bal : eachData[index]['opening_bal'],
                   
                    //NO_GST
                  
                };

                // Update invoice if id and issue_date match
                const issuedateObj = new Date(issuedate);

                function getMonday(date) {
                    const day = date.getDay(),
                          diff = date.getDate() - day + (day == 0 ? -6 : 1);
                    const monday = new Date(date.setDate(diff));
                    return monday;
                }
                
                const firstMonday = getMonday(new Date(issuedateObj.getFullYear(), issuedateObj.getMonth(), 1));
                const secondMonday = new Date(firstMonday);
                secondMonday.setDate(firstMonday.getDate() + 7);
                const thirdMonday = new Date(firstMonday);
                thirdMonday.setDate(firstMonday.getDate() + 14);
                const fourthMonday = new Date(firstMonday);
                fourthMonday.setDate(firstMonday.getDate() + 21);
                const fifthMonday = new Date(firstMonday);
                fifthMonday.setDate(firstMonday.getDate() + 28);
                
                if (issuedateObj >= firstMonday && issuedateObj < new Date(firstMonday.setDate(firstMonday.getDate() + 7)) && !showData.firstweek.issue_date) {
                    showData.firstweek = weekData;
                } else if (issuedateObj >= secondMonday && issuedateObj < new Date(secondMonday.setDate(secondMonday.getDate() + 7)) && !showData.secondweek.issue_date) {
                    showData.secondweek = weekData;
                } else if (issuedateObj >= thirdMonday && issuedateObj < new Date(thirdMonday.setDate(thirdMonday.getDate() + 7)) && !showData.thirdweek.issue_date) {
                    showData.thirdweek = weekData;
                } else if (issuedateObj >= fourthMonday && issuedateObj < new Date(fourthMonday.setDate(fourthMonday.getDate() + 7)) && !showData.fourthweek.issue_date) {
                    showData.fourthweek = weekData;
                } else if (issuedateObj >= fifthMonday && issuedateObj < new Date(fifthMonday.setDate(fifthMonday.getDate() + 7)) && !showData.fifthweek.issue_date) {
                    showData.fifthweek = weekData;
                } else {
                    remainingData.push(eachData[index]);
                }
                
              }
            // Ensure first week is not empty
            if (showData.firstweek.issue_date === '') {
                showData.firstweek = this.getEmptyWeekData();
            }

            // Recalculate totals for the current showData object
            this.calculateTotals(showData);

            // Add the showData to the final data array
            this.printShowData.push(showData);
            parentIndex++;

            // Update the remainingData for the next iteration
            eachData = remainingData;
        }

        console.log('printShowData', this.printShowData);

        // Disable loading once all data is processed
        if (i == data.length - 1) {
            this.isLoading = false;
        }
    }
}

parseNumber(value: any): number {
  return Number(value) || 0;
}

getInWord(showData: any): string {
  const toWords = new ToWords();

  const total =
    this.parseNumber(
      (showData.firstweek?.issue_total_price || 0) -
      ((showData.firstweek?.dis || 0) * (showData.firstweek?.issue_copies || 0)) +
      (showData.firstweek?.cgst || 0) +
      (showData.firstweek?.sgst || 0) +
      (showData.firstweek?.igst || 0)
    ) +
    this.parseNumber(
      (showData.secondweek?.issue_total_price || 0) -
      ((showData.secondweek?.dis || 0) * (showData.secondweek?.issue_copies || 0)) +
      (showData.secondweek?.cgst || 0) +
      (showData.secondweek?.sgst || 0) +
      (showData.secondweek?.igst || 0)
    ) +
    this.parseNumber(
      (showData.thirdweek?.issue_total_price || 0) -
      ((showData.thirdweek?.dis || 0) * (showData.thirdweek?.issue_copies || 0)) +
      (showData.thirdweek?.cgst || 0) +
      (showData.thirdweek?.sgst || 0) +
      (showData.thirdweek?.igst || 0)
    ) +
    this.parseNumber(
      (showData.fourthweek?.issue_total_price || 0) -
      ((showData.fourthweek?.dis || 0) * (showData.fourthweek?.issue_copies || 0)) +
      (showData.fourthweek?.cgst || 0) +
      (showData.fourthweek?.sgst || 0) +
      (showData.fourthweek?.igst || 0)
    ) +
    this.parseNumber(
      (showData.fifthweek?.issue_total_price || 0) -
      ((showData.fifthweek?.dis || 0) * (showData.fifthweek?.issue_copies || 0)) +
      (showData.fifthweek?.cgst || 0) +
      (showData.fifthweek?.sgst || 0) +
      (showData.fifthweek?.igst || 0)
    );

      const openingBal = parseFloat(showData.opening_bal) || 0;
         const finalAmount = total + openingBal;
  
   return toWords.convert(Math.round(finalAmount));

}



// getTotalAmount(showData: any): number {
//   return this.parseNumber(showData.firstweek ? 
//     (+ (showData['firstweek']['issue_total_price'] - showData['firstweek']['dis']|| 0) ) + (+showData.firstweek.sgst || 0) + (+showData.firstweek.cgst || 0) + (+showData.firstweek.igst || 0) : 0
//   ) +
//   this.parseNumber(showData.secondweek ? 
//    (+ (showData['secondweek']['issue_total_price'] - showData['secondweek']['dis']|| 0) ) + (+showData.secondweek.sgst || 0) + (+showData.secondweek.cgst || 0) + (+showData.secondweek.igst || 0) : 0
//   ) +
//   this.parseNumber(showData.thirdweek ? 
//     (+ (showData['thirdweek']['issue_total_price'] - showData['thirdweek']['dis']|| 0) ) + (+showData.thirdweek.cgst || 0) + (+showData.thirdweek.igst || 0) : 0
//   ) +
//   this.parseNumber(showData.fourthweek ? 
//     (+ (showData['fourthweek']['issue_total_price'] - showData['fourthweek']['dis']|| 0) ) + (+showData.fourthweek.cgst || 0) + (+showData.fourthweek.igst || 0) : 0
//   ) +
//   this.parseNumber(showData.fifthweek ? 
//    (+ (showData['fifthweek']['issue_total_price'] - showData['fifthweek']['dis']|| 0) ) + (+showData.fifthweek.cgst || 0) + (+showData.fifthweek.igst || 0) : 0
//   );
// }

private calculateWeekTotal(week: any): number {
  if (!week) return 0;
  const issuePrice = +week.issue_total_price || 0;
  const discount = week.issue_copies != null
    ? (+week.dis || 0) * (+week.issue_copies || 0)
    : (+week.dis || 0);
  const taxes = (+week.cgst || 0) + (+week.sgst || 0) + (+week.igst || 0);
  return this.parseNumber(issuePrice - discount + taxes);
}

getTotalAmount(showData: any): number {
  return this.calculateWeekTotal(showData.firstweek)
       + this.calculateWeekTotal(showData.secondweek)
       + this.calculateWeekTotal(showData.thirdweek)
       + this.calculateWeekTotal(showData.fourthweek)
       + this.calculateWeekTotal(showData.fifthweek);
}
  getTotalAmount1(showData: any): number {
    const weekTotal = this.calculateWeekTotal(showData.firstweek)
                     + this.calculateWeekTotal(showData.secondweek)
                    + this.calculateWeekTotal(showData.thirdweek)
                     + this.calculateWeekTotal(showData.fourthweek)
                     + this.calculateWeekTotal(showData.fifthweek);
 
   const openingBal = Number(showData.opening_bal) || 0;
 
   return weekTotal + openingBal;
 }
  



  
  // Function to return an empty week data object
  getEmptyWeekData() {
    return {
      id: 0,
      issue_date: '',
      advt_size: 0,
      page_no: 0,
      hsn: '-',
      advt_rate: 0,
      dis: Number(0),
      net: 0,
      cgst: 0,
      sgst: 0,
      igst: 0,
      round_off: 0,
      total: 0,
      issueName:'',
      issue_copies:Number(0),
      issue_seller_price:Number(0),
      net_amount:Number(0),
      total_amount:0,
      opening_bal:Number(0),
      issue_total_price:0,
      
    };
  }
  

  calculateNetAmount(weekData: any): number {
    if (!weekData || !weekData['total']) return 0;
    debugger
    let totalAmount = Number(weekData['total']); // Basic Amount
    let discountPercentage = Number(weekData['dis']) || 0;

    // **Step 1: Apply Discount First**
    let discountAmount = (totalAmount * discountPercentage) / 100;
    totalAmount -= discountAmount; // Subtract discount from total

    // **Step 2: If GST is Inclusive, Remove GST**
    if (weekData['gstype'] !== 'gstExclude') {
      let gstAmount = Number(weekData['cgst']) + Number(weekData['sgst']) + Number(weekData['igst']);
      totalAmount -= gstAmount; // Subtract GST only if it's included
    }

    let numR = Math.round(totalAmount);
    return numR;
  }
  // Function to calculate the total for a specific field
  calculateTotal(showData, field) {
    return ['firstweek', 'secondweek', 'thirdweek', 'fourthweek', 'fifthweek'].reduce((total, week) => {
      return total + (parseInt(showData[week][field]) || 0);
    }, 0);
  }
  
  // Function to calculate totals for showData
  calculateTotals(showData :any) {
    showData.total_amt.issue_copies = Math.round(this.calculateTotal(showData, 'issue_copies'));
    showData.total_amt.issue_seller_price = this.calculateTotal(showData, 'issue_seller_price');
    showData.total_amt.dis = this.calculateTotal(showData, 'dis');
    showData.total_amt.net = this.calculateTotal(showData, 'net');
    showData.total_amt.cgst = this.calculateTotal(showData, 'without_gst_amount');
    showData.total_amt.sgst = this.calculateTotal(showData, 'without_gst_amount');
    showData.total_amt.igst = this.calculateTotal(showData, 'without_gst_amount');
    showData.total_amt.round_off = this.calculateTotal(showData, 'round_off');
    showData.total_amt.total = this.calculateTotal(showData, 'with_gst_amount');
    showData.total_amt.without_gst_amount = this.calculateTotal(showData, 'without_gst_amount');
  
    showData.total_in_words = new ToWords().convert(showData.total_amt.total ,{ currency: true });
    showData.total = showData.total_amount;
    showData.remaining_amt = Number(showData.pre_bal) + Number(this.getTotalAmount(showData));
    showData.total_amount1 = this.getTotalAmount(showData);
  }
  
  
  

  // removeDuplicates(arr: any[]): any[] {
  //   
  //   const map = new Map();
  //   return arr.filter(item => {
  //     if (!map.has(item.DS_ISSUEDATE)) {
  //       map.set(item.DS_ISSUEDATE, true);
  //       return true;
  //     }
  //     return false;
  //   });
  // }

  // exportExcel(fileName) {}

 
  firstSunday(month, year) {
    let tempDate = new Date();
    tempDate.setHours(0, 0, 0, 0);
    // first SUNDAY of april
    tempDate.setMonth(month);
    tempDate.setFullYear(year);
    tempDate.setDate(1);

    let day = tempDate.getDay();
    let toNextSun = day !== 0 ? 7 - day : 0;
    tempDate.setDate(tempDate.getDate() + toNextSun);

    // return formatDate(tempDate, 'dd/MM/yy', 'en-IN', 'GMT+0530');
    return tempDate;
  }

  secondSunday(month, year) {
    let tempDate = new Date(this.firstSunday(month, year));

    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 7);

    let day = tempDate.getDay();
    // console.log('day', day);

    let toNextSun = day !== 0 ? 7 - day : 0;
    // console.log('toNextSun', toNextSun);
    tempDate.setDate(tempDate.getDate() + toNextSun);

    return tempDate;
  }

  thirdSunday(month, year) {
    let tempDate = new Date(this.secondSunday(month, year));
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 7);

    let day = tempDate.getDay();
    // console.log('thirdsunday', day);

    let toNextSun = day !== 0 ? 7 - day : 0;
    // console.log('toNextSun', toNextSun);
    tempDate.setDate(tempDate.getDate() + toNextSun);

    return tempDate;
  }

  fourthSunday(month, year) {
    let tempDate = new Date(this.thirdSunday(month, year));
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 7);
    let day = tempDate.getDay();
    // console.log('thirdsunday', day);
    let toNextSun = day !== 0 ? 7 - day : 0;
    // console.log('toNextSun', toNextSun);
    tempDate.setDate(tempDate.getDate() + toNextSun);

    return tempDate;
  }

  fifthSunday(month, year) {
    let tempDate = new Date(this.fourthSunday(month, year));
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 7);

    let day = tempDate.getDay();
    // console.log('thirdsunday', day);
    let toNextSun = day !== 0 ? 7 - day : 0;
    // console.log('toNextSun', toNextSun);
    tempDate.setDate(tempDate.getDate() + toNextSun);

    return tempDate;
  }

  saveAdvtInvoice() {
    console.log(this.date)
    
    this.isLoading = true;
    for (let index = 0; index < this.printShowData.length; index++) {
      let data = {
        invoice_no: this.printShowData[index]['invoice_no'],
        booking_no: this.printShowData[index]['advt_order_no'] ,
        // invoice_date: this.date,
        invoice_date:  formatDate(
          this.date,
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        ),
       
        gst_no: '27AAATH0433Q1ZI',
        pan_no: 'AAATH0433Q',
        issue_seller_name: this.printShowData[index]['advt_name'],
        first_week_id: this.printShowData[index]['firstweek']['id'],
        second_week_id: this.printShowData[index]['secondweek']['id'],
        third_week_id: this.printShowData[index]['thirdweek']['id'],
        fourth_week_id: this.printShowData[index]['fourthweek']['id'],
        fifth_week_id: this.printShowData[index]['fifthweek']['id'],
        pre_amt: this.printShowData[index]['pre_bal'],
        pay_amt: this.printShowData[index]['total_amount1'],
        remaining_amt: this.printShowData[index]['remaining_amt'],
      };

      if (data['invoice_no'] != '') {
        if (
          data['first_week_id'] != 0 ||
          data['second_week_id'] != 0 ||
          data['third_week_id'] != 0 ||
          data['fourth_week_id'] != 0 ||
          data['fifth_week_id'] != 0
        ) {
          
          // console.log(data);
          this.service.insertIssueSaleInvoice(data).subscribe((res:any) => {
              // console.log('res');
              if (index == this.printShowData.length - 1) {
                this.isLoading = false;
                alert('Issue Seller Invoice created successfully...');
                this.dialogRef.close();
              }
            }, (error) => {
              console.log(error);
              alert('Something went wrong!. Please try again..');
            }
          );
        } else {
          alert('No records found.');
        }
      } else {
        alert('Invoice no is not valid.');
      }
    }
    console.log(this.data.booking_no);

  }

  updateInvoice(){
    for (let index = 0; index < this.printShowData.length; index++) {
      let data = {
        invoice_no: this.printShowData[index]['invoice_no'],
        booking_no: this.printShowData[index]['advt_order_no'] ,
        // invoice_date: this.date,
        invoice_date:  formatDate(
          this.date,
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        ),
        // gst_no: '27AAATH0433Q1ZI',
        // pan_no: 'AAATH0433Q',
        gst_no: '27AAATH0433Q1ZI',
        pan_no: 'AAATH0433Q',
        issue_seller_name: this.printShowData[index]['advt_name'],
        first_week_id: this.printShowData[index]['firstweek']['id'],
        second_week_id: this.printShowData[index]['secondweek']['id'],
        third_week_id: this.printShowData[index]['thirdweek']['id'],
        fourth_week_id: this.printShowData[index]['fourthweek']['id'],
        fifth_week_id: this.printShowData[index]['fifthweek']['id'],
        pre_amt: this.printShowData[index]['pre_bal'],
        pay_amt: this.printShowData[index]['total'],
        remaining_amt: this.printShowData[index]['remaining_amt'],
      };

      this.service.updateIssueInvoice1(data).subscribe(
        (res) =>{
      });
  }
  this.toaster.success('success', 'data updated sucessfully');
  this.dialogRef.close()

  this.ngOnInit();
}
calculateDiscount(dis:any,total:any) {
  return  Math.round((Number(total) * Number(dis)) / 100);
}


getTotalAmtInWords(showData: any) {
  let final_amt = ['firstweek', 'secondweek', 'thirdweek', 'fourthweek', 'fifthweek']
    .reduce((sum, week) => {
      let weekData = showData[week] || {};
      let weekTotal = (this.calculateNetAmount(weekData) || 0) +
        (weekData.cgst1 || 0) +
        (weekData.sgst1 || 0) +
        (weekData.igst1 || 0);
      return sum + weekTotal;
    }, 0);

  console.log("Final Amount:", final_amt); // Debugging
  return this.convertToWords(Math.round(final_amt));
}

}
